<div class="text-center p-5">
    <div class="avatar-icon-wrapper rounded-circle m-0">
        <div
            class="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper bg-neutral-danger text-danger m-0 d-130">
            <fa-icon [icon]="['fas', 'times']" class="d-flex align-self-center display-3"></fa-icon>
        </div>
    </div>
    <h4 class="font-weight-bold mt-4">{{title}}</h4>
    <div class="pt-4">
        <button (click)="decline()" class="btn btn-pill btn-neutral-secondary mx-1" type="button">
            <span class="btn-wrapper--label">
                Cancel
            </span>
        </button>
        <button (click)="confirm()" class="btn btn-pill btn-danger mx-1" type="button">
            <span class="btn-wrapper--label">
                Delete
            </span>
        </button>
    </div>
</div>